import { useActiveCircle } from '@rhg/hooks/use-active-circle';

export const useIsRegisteredAndSponsored = () => {
    const { activeCircle, isFetched } = useActiveCircle();

    const isSponsored = isFetched ? !!activeCircle?.sponsor : undefined;
    const isRegistered = isFetched ? !!activeCircle : undefined;

    return {
        isSponsored,
        isRegistered,
        isLoading: !isFetched,
    };
};
